<template>
  <div class="element-wrapper compact px-0 px-md-3">
    <RecepcionAgregarProductoComponent :isDetallesOCCargados="isDetallesOCCargados" :facturae="facturae" :recepcion="recepcion" @refrescar="refrescar" />
    <RecepcionFacturaMiniDetalleComponent v-if="facturae" :factura_d="detalle_factura" />
    <div class="element-header" v-if="facturae">
    <h6 >Producto Recepcionado</h6>
    <div>
      <button
        type="button"
        class="btn btn-outline-danger d-flex align-items-center gap-2"
        @click="modalMalEstadoUP">
        <i class="fas fa-tasks"></i>
        Productos para devolución mal estado: 
        <span class="badge bg-danger text-white ms-1">{{ totalParaDevolver }}</span>
      </button>
    </div> <br>

      <div>
        <div
          class="mr-1 status-pill green"
          data-title="Aperturado"
          data-toggle="tooltip"
        ></div>Coincide
        <div
          class="ml-2 mr-1 status-pill red"
          data-title="Auditado"
          data-toggle="tooltip"
        ></div>No coincide
        <div
          class="ml-2 mr-1 status-pill yellow"
          data-title="Pendiente"
          data-toggle="tooltip"
        ></div> Autorizar
        <br><br>
        </div>
      </div>
    <div style="z-index: 1000 !important" class="floated-colors-btn second-floated-btn" @click="cambiarUiTabla()">
      <div class="os-toggler-w" :class="{ on: cambiar_UiTabla }">
        <div class="os-toggler-i">
          <div class="os-toggler-pill"></div>
        </div>
      </div>
      <span v-if="!cambiar_UiTabla">Tabla Detalle</span>
      <span v-if="cambiar_UiTabla">Tabla Resumen</span>
    </div>
    <div class="projects-list" v-if="facturae && cambiar_UiTabla">
      <div class="project-box white_gradient_bg_clear_light" :class="semaphoreClass(current)" style="cursor: pointer" v-for="current in facturae.facturad_resumen"
        v-bind:key="current.id" @click="verDetalleFactura(current)">
        <div class="project-head">
          <div class="project-title">
            <h5>{{ current.producto__sku }}</h5>
            <div>{{ current.producto__nombre }}</div>
            <div>{{ current.recibida_no_autorizado }}</div>
          </div>
          <br>
          <div class="row align-items-center">
            <div class="col-12">
              <div class="row">
                <div class="col-4">
                  <div class="el-tablo highlight text-center">
                    <div class="label">Ingresada</div>
                    <div class="value">
                      <h6 style="color: #3ab41d">
                        {{ current.recibida }}
                      </h6>
                    </div>
                  </div>
                </div>
                <div class="col-4">
                  <div class="el-tablo highlight text-center">
                    <div class="label">Mal</div>
                    <div class="value">
                      <h6 style="color: #3ab41d">
                        <span style="color: #3ab41d" v-if="current.recibida_mal_estado == null">
                          0</span>
                        <span style="color: red" v-else>{{
                          current.recibida_mal_estado
                        }}</span>
                      </h6>
                    </div>
                  </div>
                </div>
                <div class="col-4">
                  <div class="el-tablo highlight text-center">
                    <div class="label">No Aut.</div>
                    <div class="value">
                      <h6 style="color: #3ab41d">
                        <span style="color: #ff8001" v-if="current.recibida_no_autorizado == null">
                          0</span>
                        <span style="color: #ff8001" v-else>{{
                          current.recibida_no_autorizado
                        }}</span>
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
             <div class="col-12">
               <div class="el-tablo highlight text-left">
                 <div class="table-responsive">
                   <table class="table table-compact smaller text-faded mb-0">
                     <thead>
                       <tr>
                         <th class="text-center">Normal</th>
                         <th class="text-center">Boni</th>
                         <th class="text-right">Promo</th>
                         <th class="text-right">No Solicitado</th>
                       </tr>
                     </thead>
                     <tbody>
                       <tr>
                         <td class="text-right text-center text-success">
                           <span v-if="current.recibida_normal == null">0</span>
                           <span v-else>{{ current.recibida_normal }}</span>
                         </td>
                         <td class="text-center text-success">
                           <span v-if="current.recibida_bonificacion == null">0</span>
                           <span v-else>{{ current.recibida_bonificacion }}</span>
                         </td>
                         <td class="text-right text-success" style="padding-right: 10px">
                           <span v-if="current.recibida_promocion == null">0</span>
                           <span v-else>{{ current.recibida_promocion }}</span>
                         </td>
                         <td class="text-right" style="padding-right: 10px">
                           <span v-if="current.recibida_no_solicitado == null">0</span>
                           <span style="color: #ff8001" v-else>{{
                             current.recibida_no_solicitado
                           }}</span>
                         </td>
                       </tr>
                     </tbody>
                   </table>
                 </div>
               </div>
             </div>

            <div class="col-12">
              <div class="el-tablo highlight text-left">
                <div class="table-responsive">
                  <table class="table table-compact smaller text-faded mb-0">
                    <thead>
                      <tr>
                        <th class="text-center">Fardos</th>
                        <th class="text-center">Unidad Medida</th>
                        <th class="text-right">Unidades</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="fardo in current.fardos" v-bind:key="fardo.id">
                        <td class="text-right text-center text-success">
                          {{ fardo.cantidad_um }}
                        </td>
                        <td class="text-center text-success">
                          {{ fardo.unidad_medida__nombre }}
                        </td>
                        <td class="text-right text-success" style="padding-right: 10px">
                          {{ fardo.unidades_totales }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="projects-list" v-if="facturae && !cambiar_UiTabla">
      <div class="project-box" style="cursor: pointer" v-for="current in facturae.facturad_set" v-bind:key="current.id"
        @click="verDetalleLinea(current)">
        <div v-if="current.facturadmalestado_set && current.facturadmalestado_set[0]" v-bind:class="{
          'status-pill blue': current.facturadmalestado_set[0].afecta_oc == true,
          'status-pill grey': current.facturadmalestado_set[0].afecta_oc == false,
        }" style="float: right"></div>
        <div class="project-head">
          <div class="project-title">
            <h5>{{ current.producto_obj.sku }}</h5>
            <div>{{ current.producto_obj.nombre }}</div>
            <br>
            <table class="table table-lightborder">
              <thead>
                <tr></tr>
              </thead>
              <tbody>
                <tr>
                  <td class="text-left">Precio Linea:</td>
                  <td class="text-right">
                    <span style="color: OrangeRed">Q{{ (Number(current.precio_unidad_real) * Number(current.cantidad_total)).toFixed(2) }}</span>
                  </td>
                </tr>
                <tr>
                  <td class="text-left">Precio Unitario:</td>
                  <td class="text-right">
                    <span style="color: OrangeRed">Q{{ current.precio_unidad_real }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
            <small v-if="current && current.descripcion">
              {{ current.descripcion }}
            </small>
            <hr />
            <span class="sub-value">{{ current.tarima }}</span>
            <small>
              <div class="value text-success" v-if="current.estado == 'A'">
                {{ current.estado_str }}
              </div>
              <div class="value text-info" v-if="current.estado == 'B'">
                {{ current.estado_str }}
              </div>
              <div class="value text-secondary" v-if="current.estado == 'P'">
                {{ current.estado_str }}
              </div>
              <div class="value text-danger" v-if="current.estado == 'N'">
                {{ current.estado_str }}
              </div>
              <div class="value text-info" v-if="current.estado == 'S'">
                {{ current.estado_str }}
              </div>
              <div class="value text-danger" v-if="current.estado == 'X'">
                {{ current.estado_str }}
              </div>
              <div class="value text-danger" v-if="current.estado == 'U'">
                {{ current.estado_str }}
              </div>
            </small>
          </div>
        </div>
        <div class="project-info">
          <div class="row align-items-center">
            <div class="col-12">
              <div class="row">
                <div class="col-6">
                  <div class="el-tablo highlight text-center">
                    <div class="label">Total</div>
                    <div class="value">
                      <h6 h1 style="color: #3ab41d" class="text-info">
                        {{ current.cantidad_total }}
                      </h6>
                    </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="el-tablo highlight text-center">
                    <div class="label">Ing.</div>
                    <div class="value">
                      <h6 h1 style="color: #3ab41d">
                        {{ current.cantidad }}
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="row">
                <div class="col-6">
                  <div class="el-tablo highlight text-center">
                    <div class="label">Mal</div>
                    <div class="value">
                      <h6 h1 style="color: #3ab41d" class="text-danger">
                        {{ current.cantidad_mal_estado }}
                      </h6>
                    </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="el-tablo highlight text-center">
                    <div class="label">OC</div>
                    <div class="value" v-if="current.orden_compra_d">
                      <h6 h1 style="color: #1949bf">
                        {{ current.orden_compra_d.cantidad }}
                      </h6>
                    </div>
                    <div v-else>
                      <small h1 style="color: #1949bf"> No tiene </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div aria-hidden="true" class="onboarding-modal modal fade animated" id="onboardingSlideModal" role="dialog"
      tabindex="-1">
      <div class="modal-dialog modal-centered" role="document">
        <div class="modal-content text-center">
          <button aria-label="Close" class="close" @click="hideModal" type="button">
            <span class="close-label">Cerrar</span>
            <span class="os-icon os-icon-close"></span>
          </button>
          <div class="onboarding-slider-w">
            <div class="onboarding-slide">
              <div class="onboarding-content with-gradient">
                <h4 class="onboarding-title">Opciones</h4>
                <div class="row">
                  <div class="col-12">
                    <button type="button" @click="eliminarLinea(detalle_actual)" class="btn btn-block btn-md btn-danger">
                      Eliminar Linea
                    </button>
                    <br />
                  </div>

                </div>
              </div>
            </div>
            <div class="onboarding-slide">
              <div class="onboarding-content with-gradient">
                <h4 class="onboarding-title" v-if="detalle_actual">
                  {{ detalle_actual.producto_obj.sku }}
                </h4>
                <div class="onboarding-text" v-if="detalle_actual">
                  {{ detalle_actual.producto_obj.nombre }}
                </div>
                <div class="row">
                  <div class="col-sm-12">
                    <table class="table table-lightborder table-bordered table-v-compact mb-0" v-if="detalle_actual">
                      <tbody>
                        <tr>
                          <td>
                            <div class="balance-label smaller lighter">Precio OC</div>
                            <strong>{{ detalle_actual.precio_oc }}</strong>
                          </td>
                          <td class="d-sm-none d-xxxxl-table-cell d-md-table-cell d-xxl-none">
                            <div class="balance-label smaller lighter">Precio Unidad</div>
                            <strong>{{ detalle_actual.precio_unidad }}</strong>
                          </td>
                          <td>
                            <div class="balance-label smaller lighter">Precio Linea</div>
                            <strong>{{ detalle_actual.precio }}</strong>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div class="balance-label smaller lighter text-nowrap">
                              Pedida
                            </div>
                            <strong>
                              <span v-if="detalle_actual.orden_compra_d">{{
                                detalle_actual.orden_compra_d.cantidad
                              }}</span>
                              <span v-if="!detalle_actual.orden_compra_d">0</span>
                            </strong>
                          </td>
                          <td>
                            <div class="balance-label smaller lighter text-nowrap">
                              Lote
                            </div>
                            <strong>
                              <span v-if="detalle_actual.producto_lote">{{
                                detalle_actual.producto_lote.codigo_lote
                              }}</span>
                              <span v-if="!detalle_actual.producto_lote">UNICO</span>
                            </strong>
                          </td>
                          <td class="d-sm-none d-xxxxl-table-cell d-md-table-cell d-xxl-none">
                            <div class="balance-label smaller lighter text-nowrap">
                              Estado
                            </div>
                            <strong>{{ detalle_actual.estado_str }}</strong>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div class="balance-label smaller lighter">OC #</div>
                            <strong>
                              <span v-if="seleccion_oc">{{ seleccion_oc.numero }}</span>
                        RecepcionFacturaDetalleComponent      <span v-if="!seleccion_oc">SIN OC</span>
                            </strong>
                          </td>
                          <td>
                            <div class="balance-label smaller lighter">Creo OC</div>
                            <strong>
                              <span v-if="seleccion_oc">{{
                                seleccion_oc.usuario.name
                              }}</span>
                              <span v-if="!seleccion_oc">SIN OC</span>
                            </strong>
                          </td>
                          <td class="d-sm-none d-xxxxl-table-cell d-md-table-cell d-xxl-none">
                            <div class="balance-label smaller lighter">Fecha OC</div>
                            <strong v-if="seleccion_oc">{{ seleccion_oc.fecha }}</strong>
                            <span v-if="!seleccion_oc">SIN OC</span>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="3">
                            <div class="balance-label smaller lighter">Cantidad</div>
                            <h1>
                              <strong>
                                {{ detalle_actual.cantidad }}
                              </strong>
                            </h1>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div class="onboarding-slide">
              <div class="onboarding-content with-gradient">
                <h4 class="onboarding-title">Inventario en Sitio</h4>
                <div class="row">
                  <div class="col-sm-12">
                    <table class="table table-clean text-left">
                      <tbody v-for="existencia in producto_tienda" :key="existencia.ID">
                        <tr>
                          <td>
                            <div class="value">Existencia Actual</div>
                          </td>
                          <td class="text-right">
                            <div class="value">
                              {{ existencia.existencia }}
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div class="value">Minimo</div>
                          </td>
                          <td class="text-right">
                            <div class="value">
                              {{ existencia.minimo }}
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div class="value">Maximo</div>
                          </td>
                          <td class="text-right">
                            <div class="value">
                              {{ existencia.maximo }}
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <br />
                    <div class="invoice-table text-left">
                      <table class="table">
                        <thead>
                          <tr>
                            <th>Tipo</th>
                            <th>Cantidad</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>{{ detalle_actual.estado_str }}</td>
                            <td class="text-right">
                              {{ detalle_actual.cantidad }}
                            </td>
                          </tr>
                          <tr v-for="mal_estado_det in detalle_actual.facturadmalestado_set" :key="mal_estado_det.id">
                            <td>{{ mal_estado_det.mal_estado_str }}</td>
                            <td class="text-right">
                              {{ mal_estado_det.cantidad }}
                            </td>
                          </tr>
                        </tbody>
                        <tfoot>
                          <tr>
                            <td>Total</td>
                            <td class="text-right">
                              {{ detalle_actual.cantidad_total }}
                            </td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--  MODAL PRODUCTOS MAL ESTADO -->
    <div class="modal fade" id="modalMalEstado" tabindex="-1" aria-labelledby="modalMalEstadoLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header bg-danger text-white">
            <h5 class="modal-title" id="modalMalEstadoLabel">Detalle de Productos en Mal Estado</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            
            <!-- Lista de productos en mal estado -->
            <div v-if="listaMalEstado.length > 0 || listaNoRecibidos.length > 0">
              <!-- SECCIÓN 1: Productos en Mal Estado -->
              <div v-if="listaMalEstado.length > 0" class="mb-4">
                <h5 class="text-danger fw-bold mb-3">Productos en Mal Estado</h5>
                <div class="list-group">
                  <div v-for="(item, index) in listaMalEstado" :key="'mal-' + index" class="list-group-item list-group-item-action mb-2 border rounded">
                    
                    <!-- Encabezado del Producto usando el método -->
                    <div class="d-flex w-100 justify-content-between align-items-center mb-1">
                      <h6 class="mb-1 text-danger fw-bold">
                        {{ obtenerNombreProducto(item) }}
                      </h6>
                      <span class="badge bg-secondary text-white">SKU: {{ item.producto_obj ? item.producto_obj.sku : 'N/A' }}</span>
                    </div>
                    
                    <p class="mb-2 text-muted small">Cantidad total en mal estado: <strong>{{ item.cantidad_mal_estado }}</strong></p>

                    <!-- Sub-lista de detalles de mal estado -->
                    <div class="bg-light p-2 rounded border">
                      <span class="small fw-bold text-dark d-block mb-1">Detalles de afectación:</span>
                      <ul class="mb-0 ps-3">
                        <li v-for="(detalle, dIndex) in item.facturadmalestado_set" :key="dIndex" class="small">
                          <span class="badge bg-warning text-dark me-1">{{ detalle.mal_estado_str }}</span>
                          Cantidad afectada: <strong>{{ detalle.cantidad }}</strong> 
                        </li>
                      </ul>
                    </div>

                  </div>
                </div>
              </div>


              <!-- SECCIÓN 2: Productos No Recibidos (Estado N) -->
              <div v-if="listaNoRecibidos.length > 0" class="mb-4">
                <h5 class="text-warning fw-bold mb-3">Productos No Recibidos / No Solicitados</h5>
                <div class="list-group">
                  <div v-for="(item, index) in listaNoRecibidos" :key="'n-' + index" class="list-group-item list-group-item-action mb-2 border rounded">
                    
                    <!-- Encabezado del Producto usando el método -->
                    <div class="d-flex w-100 justify-content-between align-items-center mb-1">
                      <h6 class="mb-1 text-warning fw-bold">
                        {{ obtenerNombreProducto(item) }}
                      </h6>
                      <span class="badge bg-secondary text-white">SKU: {{ item.producto_obj ? item.producto_obj.sku : 'N/A' }}</span>
                    </div>
                    
                    <p class="mb-2 text-muted small">Cantidad total: <strong>{{ item.cantidad_total }}</strong></p>

                    <!-- Sub-lista con el texto quemado -->
                    <div class="bg-light p-2 rounded border">
                      <span class="small fw-bold text-dark d-block mb-1">Detalles de afectación:</span>
                      <ul class="mb-0 ps-3">
                        <li class="small">
                          <span class="badge bg-dark text-white me-1">No Solicitado en Orden de Compra</span>
                          Cantidad afectada: <strong>{{ item.cantidad_total }}</strong> 
                        </li>
                      </ul>
                    </div>

                  </div>
                </div>
              </div>
            </div>

            <p v-else class="text-center text-muted my-3">No hay registros disponibles.</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal" aria-label="Close"">Cerrar</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="modalModificarLinea" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-sm" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Modificar Linea</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="col-12">
              <label>Precio de Linea</label>
              <input type="number" class="form form-control" v-model="detalle_actual.precio_real" />
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              Cancelar
            </button>
            <button type="button" @click="modificarLinea" class="btn btn-primary">
              Guardar cambio
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import RecepcionAgregarProductoComponent from "@/components/wms/recepcion/RecepcionAgregarProductoComponent";
import RecepcionFacturaMiniDetalleComponent from "@/components/wms/recepcion/RecepcionFacturaMiniDetalleComponent";
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";

export default {
  components: {
    RecepcionAgregarProductoComponent,
    RecepcionFacturaMiniDetalleComponent,
  },
  data() {
    return {
      cambiar_UiTabla: true,
      detalle: {},
      seleccion_oc: "",
      filtro_sku: null,
      producto_tienda: [],
      detalle_factura: "",
      detalle_actual: {
        id: null,
        estado_str: null,
        producto_obj: {
          sku: null,
          nombre: null,
          ultimo_precio_compra: 0,
          fecha_creacion: null,
          permitir_venta: true,
          permitir_compra: true,
          consumible: false,
          activo: true,
          es_servicio: false,
          es_activo_fijo: false,
          categoria: null,
        },
        producto_lote: null,
        posicion: null,
        orden_compra_d: null,
        tarima: null,
        cantidad: 0,
        precio_oc: null,
        precio: null,
        precio_unidad: null,
        observaciones: null,
        fecha_creacion: null,
        estado: null,
        fecha_sol_autorizacion: null,
        fecha_autorizacion: null,
        factura_e: null,
        fardos: [],
        producto: null,
        usuario: null,
        usuario_autoriza: null,
      },
    };
  },
  props: ["facturae", "recepcion", "isDetallesOCCargados"],
  computed: {
    ...mapGetters({
      selectedInvoice: 'recepciones/selectedInvoice'
    }),
    lista_agrupada() {
      const result = {};

      let key = "producto";
      if (!this.facturae) {
        return [];
      }

      this.facturae.facturad_set.forEach((item) => {
        if (!result[item[key]]) {
          result[item[key]] = [];
        }
        result[item[key]].push(item);
      });
      return result;
    },
    productos_unicos() {
      if (this.facturae) {
        return _.uniq(this.facturae.facturad_set, "producto_obj");
      }
      return [];
    },
    listaMalEstado() {
      if (!this.facturae || !this.facturae.facturad_set) {
        return [];
      }

      // Filtramos solo los elementos que tienen cantidad en mal estado y su respectiva lista
      return this.facturae.facturad_set.filter(item => 
        item.cantidad_mal_estado > 0 && 
        item.facturadmalestado_set && 
        item.facturadmalestado_set.length > 0
      );
    },
    listaNoRecibidos() {
      if (!this.facturae || !this.facturae.facturad_set) {
        return [];
      }

      return this.facturae.facturad_set.filter(item => 
        item.estado === 'N' && item.orden_compra_d == null
      );
    },
    totalParaDevolver(){
      return this.listaMalEstado.length + this.listaNoRecibidos.length
    },
  },
  mounted() { },
  methods: {
    obtenerNombreProducto(item) {
      // Verificamos si el producto_id o el sku es 'T00993'
      const esT00993 = 
        item.producto_id === 'T00993' || 
        (item.producto_obj && item.producto_obj.sku === 'T00993');

      if (esT00993) {
        return item.descripcion;
      }

      // Si no es T00993, devolvemos el nombre normal del objeto o un texto por defecto
      return item.producto_obj ? item.producto_obj.nombre : 'Producto sin nombre';
    },
    modalMalEstadoUP(){
      $("#modalMalEstado").modal("show");
    },
    semaphoreClass(current) {
      if (current.recibida_no_autorizado > 0) {
        return 'semaphore-yellow';
      } else if (current.pendiente_suma > 0 || current.orden_compra_d === null) {
        return 'semaphore-red';
      } else if (current.pendiente_suma === 0) {
        return 'semaphore-green';
      }
      return '';
    },
    verDetalleFactura(d) {
      let self = this;
      DynamicService.getAction(
        "wms",
        "facturas",
        self.facturae.id,
        "obtener_linea_detalle",
        {
          producto: d.producto__sku,
        }
      ).then((response) => {
        self.detalle_factura = response.data;
        self.fardos = d.fardos;
        $("#detalleRecepcion").modal("show");
      });
    },
    modificarLinea() {
      let self = this;
      DynamicService.postAction(
        "wms",
        "facturas",
        self.facturae.id,
        "modificar_detalle_factura",
        {
          id: this.detalle_actual.id,
          precio_real: this.detalle_actual.precio_real,
        }
      )
        .then((response) => {
          self.refrescar();
          Notifications.alert.success(
            "Modificar Detalle de Factura",
            "Realizado Exitosamente"
          );
          $("#modalModificarLinea").modal("hide");
        })
        .catch((error) => {
          Notifications.alert.error("Modificar Factura", "Ha ocurrido un error");
        });
    },
    modificarDetalleFactura() {
      $("#onboardingSlideModal").modal("hide");
      $("#modalModificarLinea").modal("show");
    },
    solicitarAutorizacion() {
      let self = this;
      DynamicService.postAction(
        "wms",
        "facturas",
        self.facturae.id,
        "solicitar_autorizacion_linea",
        { id: self.detalle_actual.id }
      )
        .then((response) => {
          Notifications.alert.success(
            "Autorización de Linea",
            "Fue generado Correctamente. "
          );
          $("#onboardingSlideModal").modal("hide");
          self.refrescar();
        })
        .catch((err) => {
          if (err.response.data.detail) {
            Notifications.alert.error("Autorización de Linea", err.response.data.detail);
            return;
          }
          Notifications.alert.error(
            "Autorización de Linea",
            "No se pudo autorizar la linea. "
          );
        });
    },
    seleccionar() {
      let self = this;
      self.$emit("seleccion", self.facturae.id);
    },
    verDetalleLinea(linea) {
      let self = this;
      if (this.facturae.estado == "9") {
        alert("Factura se encuentra anulada");
        return;
      }
      if (this.facturae.estado == "C") {
        alert("Factura se encuentra Finalizada");
        return;
      }
      if (this.facturae.estado == "B") {
        alert("Factura se encuentra Cerrada");
        return;
      }
      this.seleccion_oc = "";
      if (linea.orden_compra_d) {
        DynamicService.getById(
          "compras",
          "orden_compra_e",
          linea.orden_compra_d.orden_compra_e
        ).then((response) => {
          this.seleccion_oc = response.data;
        });
      }

      self.detalle_actual = linea;
      self.showModal();
    },
    hideModal() {
      $("#onboardingSlideModal").modal("hide");
    },
    showModal() {
      let self = this;
      let params = {
        producto: self.detalle_actual.producto,
        tienda: self.recepcion.tienda,
        quitar_paginacion: true,
      };
      DynamicService.fetch("cat", "producto-tienda", params).then((res) => {
        self.producto_tienda = res.data;
      });
      $("#onboardingSlideModal").modal("show");

      $("#onboardingSlideModal.show-on-load").modal("show");
      if ($("#onboardingSlideModal .onboarding-slider-w").length) {
        $("#onboardingSlideModal .onboarding-slider-w").slick({
          dots: true,
          infinite: false,
          adaptiveHeight: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          prevArrow:
            '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" aria-disabled="false" style="">Anterior</button>',
          nextArrow:
            '<button class="slick-next slick-arrow" aria-label="Next" type="button" style="" aria-disabled="false">Next</button>',
        });
        $("#onboardingSlideModal").on("shown.bs.modal", function (e) {
          $("#onboardingSlideModal .onboarding-slider-w").slick("setPosition");
        });
        $("#onboardingSlideModal").on("hide.bs.modal", function (e) {
          $("#onboardingSlideModal .onboarding-slider-w").slick("unslick");
        });
      }
    },
    refrescar() {
      this.seleccionar();
    },
    eliminarLinea(linea) {
      let self = this;
      let params = {
        id: linea.id,
      };
      DynamicService.postAction(
        "wms",
        "facturas",
        self.facturae.id,
        "eliminar_detalle_factura",
        params
      )
        .then((res) => {
          self.hideModal();
          self.refrescar();
          Notifications.alert.success(
            "Eliminación",
            "Se ha eliminado la linea correctamente"
          );
        })
        .catch((err) => {
          console.log(err);
          Notifications.alert.error(
            "Eliminación de Linea",
            "No se ha podido eliminar la linea. "
          );
        });
    },
    cambiarUiTabla() {
      let self = this;
      self.cambiar_UiTabla = !self.cambiar_UiTabla;
    },
  },
};
</script>

<style scoped>
</style>
